/** The Reviews page's groups: one per topic, documents without one under "Uncategorized". */
import type { AdminReviewDoc } from "../api/admin";

export interface TopicGroup {
  id: string;
  name: string;
  docs: AdminReviewDoc[];
}

export const UNCATEGORIZED = "uncategorized";

/** Documents by topic, each in server order. A group sits where its first
 * document stands in the server's triage order – priority, then oldest filing. */
export function groupByTopic(rows: AdminReviewDoc[]): TopicGroup[] {
  const groups = new Map<string, TopicGroup>();
  for (const doc of rows) {
    const id = doc.topic?.id ?? UNCATEGORIZED;
    const group = groups.get(id) ?? { id, name: doc.topic?.name ?? "Uncategorized", docs: [] };
    group.docs.push(doc);
    groups.set(id, group);
  }
  return [...groups.values()];
}

/** A copy of `folded` with `id` flipped – the groups' fold state. */
export function toggled(folded: ReadonlySet<string>, id: string): Set<string> {
  const next = new Set(folded);
  if (next.has(id)) next.delete(id);
  else next.add(id);
  return next;
}
